import { useAppDispatch, useAppSelector } from "../../reducers";
import { stepInformation } from "../constants";
import {
    OptionStepsType,
    StepDataType,
    StepInformationKeyType,
} from "../models";
import { onSelectOption } from "../reducers";

interface IUseStepInformationProps {
    step?: keyof OptionStepsType;
}

export const useStepInformation = (
    props: IUseStepInformationProps,
): {
    stepInfo: {
        key: StepInformationKeyType;
        heading: string | null;
        data: readonly StepDataType[];
        description: string;
    };
    selectedLevel: number;
    selectedData: StepDataType | undefined;
    onClick: (option: StepDataType) => Promise<void>;
} | null => {
    const { selections } = useAppSelector((state) => state.mattressmatch.ui);
    const dispatch = useAppDispatch();
    const { step } = props;
    if (!step) {
        return null;
    }
    const info = stepInformation[step];

    const onClick = async (option: StepDataType): Promise<void> => {
        if (!step) {
            return;
        }
        dispatch(
            onSelectOption({
                selectedOption: option.level,
                step: step,
            }),
        );
    };

    return {
        stepInfo: info,
        selectedLevel: selections[info.key],
        selectedData: info.data.find((d) => d.level === selections[info.key]),
        onClick: onClick,
    };
};
